



















import Vue, { PropType } from "vue";
import qs from "qs";

export interface saleCurrencySelectProps {
  baseSaleUrl: string;
  currencyList: any;
  initialCurrencyCode: string;
}

export interface saleCurrencySelectData {
  currencyCode: string;
  params: any;
}

export default Vue.extend({
  name: "vc-sale-currency-select",
  props: {
    baseSaleUrl: {
      type: String as PropType<saleCurrencySelectProps["baseSaleUrl"]>,
      default: ""
    },
    currencyList: {
      type: Array as PropType<saleCurrencySelectProps["currencyList"]>,
      default: () => {}
    },
    initialCurrencyCode: {
      type: String as PropType<saleCurrencySelectProps["initialCurrencyCode"]>,
      default: ""
    }
  },
  data(): saleCurrencySelectData {
    return {
      currencyCode: this.initialCurrencyCode,
      params: qs.parse(window.location.search.replace("?", ""))
    };
  },
  methods: {
    changeCurrencyCode() {
      let urlParams = qs.parse(window.location.search.replace("?", ""));
      urlParams["currencyCode"] = this.currencyCode;
      const replaceUrl = this.baseSaleUrl + "?" + qs.stringify(urlParams);
      history.replaceState(null, "", replaceUrl);
      window.location.reload();
    }
  }
});
